import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;

// ────────────────────────────────────────────────────────────
//  Helpers
// ────────────────────────────────────────────────────────────
const postJson = async (url, payload) =>
    axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });

const postForm = async (url, formData) =>
    axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// ─────────────────────────  Ortak Backdrop  ─────────────────────────
// Bootstrapʼin kendi .modal-backdrop sınıfıyla beraber extra blur efekti veriyoruz.
const Backdrop = () => (
    <div
        className="modal-backdrop fade show"
        style={{ backdropFilter: 'blur(3px)', zIndex: 1050 }}
    />
);

// Helper: ortak modal wrapper (backdrop + dialog)
const ModalShell = ({ children }) => (
    <>
        <Backdrop />
        {children}
    </>
);
export function IssueModal({ show, onClose, examInfo, onSaved }) {
    const [title, setTitle] = useState('');
    const [description, setDesc] = useState('');
    const [file, setFile] = useState(null);
    const [saving, setSaving] = useState(false);

    if (!show) return null;

    const alreadyDone = examInfo.hasIssue;

    const handleSave = () => {
        if (alreadyDone) return onClose();
        if (!title.trim()) return Swal.fire('Başlık gerekli', '', 'info');

        setSaving(true);
        const fd = new FormData();
        fd.append('TimeSlotId', examInfo.timeSlotId);
        fd.append('ClassroomId', examInfo.classroomId);
        fd.append('Title', title);
        fd.append('Description', description);
        if (file) fd.append('File', file);

        postForm(`${API_URL}/Custom/ReportIssue`, fd)
            .then(() => {
                Swal.fire({ icon: 'success', title: 'Sorun kaydedildi', timer: 1500, showConfirmButton: false });
                onSaved?.('issue', examInfo);
                onClose();
            })
            .catch(() => Swal.fire('Hata', 'Sorun kaydedilemedi', 'error'))
            .finally(() => setSaving(false));
    };

    return (
        <ModalShell>
            <div className="modal fade show" style={{ display: 'block', zIndex: 1051 }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Sorun Bildir</h5>
                            <button className="btn-close" onClick={onClose} />
                        </div>
                        <div className="modal-body">
                            <p className="mb-3 alert alert-danger">
                                Sınav sırasında birden fazla sorun yaşanma ihtimali nedeniyle bu formu doldurmadan önce sınavın sonlanmasını beklemeniz daha sağlıklı olacaktır.
                            </p>
                            <p className="mb-3">
                                <strong>{examInfo.examName}</strong> – {examInfo.classroomCode}<br />
                                {examInfo.date} {examInfo.startTime}-{examInfo.endTime}
                            </p>

                            {alreadyDone && (
                                <div className="alert alert-warning d-flex align-items-center" role="alert">
                                    <i className="bi bi-exclamation-circle me-2" /> Bu sınav için sorun bildirimi zaten yapılmış.
                                </div>
                            )}

                            {!alreadyDone && (
                                <>
                                    <input type="text" className="form-control mb-3" placeholder="Sorun Tanımı"
                                        value={title} onChange={e => setTitle(e.target.value)} />

                                    <textarea rows={3} className="form-control mb-3" placeholder="Detaylı Açıklama"
                                        value={description} onChange={e => setDesc(e.target.value)} />

                                    <p className="mb-2 small text-muted">Kanıt dosyası - tutanak vb. (fotoğraf / pdf) ekleyebilirsiniz.</p>
                                    <input type="file" className="form-control" accept="image/*,application/pdf"
                                        onChange={e => setFile(e.target.files[0])} />
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>Kapat</button>
                            {!alreadyDone && (
                                <button className="btn btn-danger" onClick={handleSave} disabled={saving}>Kaydet</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ModalShell>
    );
}
